import React from 'react';
import { styled } from '@teko/ds-desktop';
import { getTrackingData } from '@teko/tracking';
import ZaloLogo from 'assets/zalo-logo.svg';

interface IZaloIconProps {
  url: string;
  bottom?: number;
}

export const ZaloIcon: React.FC<IZaloIconProps> = ({ url }) => {
  return (
    <Wrapper
      href={url}
      target="_blank"
      rel="noreferrer"
      {...getTrackingData({
        isTrackContent: true,
        regionName: 'quickAction',
        contentName: 'zaloMessengerIcon',
      })}
    >
      <img src={ZaloLogo} alt="zalo-logo" width={42} height={42} />
    </Wrapper>
  );
};

const Wrapper = styled.a`
  cursor: pointer;
  @media print {
    display: none;
  }
`;
